import Vue from 'vue';

export default (store) => {
  store.subscribeAction({
    before: (action, state) => {
      Vue.set(state, 'isProcessingData', true);
    },
    after: (action, state) => {
      Vue.set(state, 'isProcessingData', false);
    },
  });
};
